import axiosInstance from "../../utils/axiosInstance";

const mediaService = {

    uploadImage: async (file, module) => {

        const formData = new FormData();

        formData.append("file", file);

        const response = await axiosInstance.post(
            `/Media/image?module=${module}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;

    }

};

export default mediaService;